// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button[data-testid="*/*/back_button"],
button[data-testid="community_profile_page/community_header/menu_button"],
nav[data-testid="community_profile_page/*/community_profile_tab"] {
    display: none;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
